var map = {
	"./1.png": "1c02",
	"./2.png": "6ad8",
	"./3.png": "45f4",
	"./4.png": "eba2",
	"./Group_22.png": "493d",
	"./Light_off.png": "baa0",
	"./Light_on.png": "e8d4",
	"./bg_floor_1.png": "10e3",
	"./bg_floor_2.png": "486f",
	"./bg_floor_3.png": "0c40",
	"./bg_floor_4.png": "d97d",
	"./door_close.png": "c546",
	"./door_open.png": "eef0",
	"./gateway.png": "598e",
	"./isentenance.png": "7edc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "868c";